import { lazy, Suspense } from 'react'
import { Redirect, Route } from 'react-router-dom'
import RoutesWithNotFound from 'utilities/routes-with-not-found'
import { useSurveyRedirect } from 'contexts/survey-context/useSurvey'
import { SurveyTypeEnum } from 'contexts/survey-context/survey.interface'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { RoutesAlbumDefinitions } from './configs/routes/definitions'
import { AlbumProvider } from './context'
import AlbumPopup from './components/album-popup'

const Start = lazy(() => import('./views/start'))
const Error = lazy(() => import('./views/error'))
const Congrats = lazy(() => import('./views/congrats'))
const RedirectView = lazy(() => import('./views/redirect'))
const Album = () => {
  const [{ user }] = useSession()
  const { history, pathname } = useRouter()

  useSurveyRedirect(SurveyTypeEnum.VOTE)

  const handleClick = () => {
    gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Album - Comencemos', value: '10' })
    dlTrackEvent('user_interaction', { action: 'click', element: 'comencemos', section: 'album' })

    localStorage.setItem('internal_redirect', pathname)
    return history.push('/start')
  }

  if (!user) {
    return <AlbumPopup handleClick={handleClick} />
  }

  return (
    <Suspense fallback={<>Cargando</>}>
      <AlbumProvider>
        <RoutesWithNotFound>
          <Route path="/album" component={() => <Redirect to="/album/start" />} exact />
          <Route path="/album/start" component={Start} exact />
          <Route path="/album/error" component={Error} exact />
          <Route path="/album/congrats" component={Congrats} exact />
          <Route path="/album/redirect/:rallyType/:url" component={RedirectView} exact />
          {RoutesAlbumDefinitions.map((route, index) => (
            <Route key={index} path={route.path} component={route.component} exact={route.exact} />
          ))}
        </RoutesWithNotFound>
      </AlbumProvider>
    </Suspense>
  )
}

export default Album
